<template>
    <header>
        <nav class="navbar">
            <img src="../../assets/logo.png"
                 class="nav-logo"
                 title="99Math"
                 alt="99Math"
                 @click="redirectHome"
            />
        </nav>
    </header>
</template>
<script>
    export default {
        methods: {
            redirectHome() {
                if (this.$router.currentRoute.name === 'play') {
                    if (!confirm('Are yu sure you want to quit the game?')) {
                        this.$ga.event({
                            eventCategory: 'logo',
                            eventAction: 'click',
                            eventLabel: 'logoClickCanceled',
                        });
                        return;
                    }
                }
                this.$ga.event({
                    eventCategory: 'logo',
                    eventAction: 'click',
                    eventLabel: 'redirectHome',
                });
                return this.$router.push({ name: 'home' });
            }
        }
    }
</script>
<style scoped lang="scss">
    header nav {
        height: 4rem;
        background-color: #7822CC;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, .4);
        img {
            width: 145px;
            height: 50px;
            cursor: pointer;
        }
    }

</style>
